/**
 * Global Store - React state management with localStorage persistence
 *
 * Usage:
 * - For React apps: import from "@repo/global-store"
 * - For explicit React adapter: import from "@repo/global-store/react"
 */

// Export React adapter by default
export * from "./adapters/react";

// Export shared fallback popup state store
export * from "./fallback-popup";

// Export persistence strategies
export * from "./persistence";
